
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mattilda",
      function () {
        return require("private-next-pages/mattilda/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mattilda"])
      });
    }
  